[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 5,
                "y": 7,
                "key": "xMSu7"
            },
            {
                "x": 3,
                "y": 7,
                "key": "4St2N"
            },
            {
                "x": 3,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 3,
                "y": 7,
                "key": "RBCT-"
            },
            {
                "x": 3,
                "y": 5,
                "key": "6zmsi"
            },
            {
                "x": 5,
                "y": 5,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 5,
                "y": 3,
                "key": "Y_QtY"
            },
            {
                "x": 7,
                "y": 3,
                "key": "87Arv"
            },
            {
                "x": 7,
                "y": 5,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 9,
                "y": 5,
                "key": "NjyBq"
            },
            {
                "x": 9,
                "y": 7,
                "key": "fSGPv"
            },
            {
                "x": 9,
                "y": 7,
                "key": "yISFx"
            },
            {
                "x": 8,
                "y": 7,
                "key": "VjHMM"
            },
            {
                "x": 7,
                "y": 7,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 7,
                "y": 10,
                "key": "SNZ-8"
            },
            {
                "x": 5,
                "y": 10,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    }
]